<template>
  <div class="nodeflow-components">
    <!-- 节点类型不是条件分支时显示普通节点 -->
    <div class="node-wrap" v-if="nodeConfig.type != 4">
      <!-- 发起人节点 --> 
      <div class="node-wrap-box start-node" v-if="nodeConfig.type == 0" :class="(nodeConfig.error ? 'active error' : '')">
        <div @click="setStart()">
          <div class="title" style="background: rgb(64, 158, 255);">
            <!-- <i class="iconfont icon-faqi"></i> -->
            <span class="editable-title">{{ nodeConfig.nodeName }}</span>
          </div>
          <div class="content">
            <div class="text">
              <!-- 修改判断逻辑，特殊处理ALL类型 -->
              <span class="placeholder" v-if="!nodeConfig.nodeUserType || (nodeConfig.nodeUserType.type !== 'ALL' && (!nodeConfig.nodeUserType.valueList || nodeConfig.nodeUserType.valueList.length === 0))">
                请选择{{ placeholderList[nodeConfig.type] }}
              </span>
              <div v-else :title="setApproverStr(nodeConfig)" class="ellipsis"> {{ setApproverStr(nodeConfig) }}</div>
            </div>
            <i class="el-icon-arrow-right arrow"></i>
          </div>
          <div class="error_tip" v-if="isTried && nodeConfig.error">
            <i class="el-icon-warning" style="color: rgb(242, 86, 67);"></i>
          </div>
        </div>
      </div>
      
      <!-- 审批人/抄送人节点 -->
      <div class="node-wrap-box" v-else-if="nodeConfig.type && nodeConfig.type != 0" :class="(isTried && nodeConfig.error ? 'active error' : '')">
        <div @click="setPerson(null, null, null, null)">
          <div class="title" :style="
                        'background: rgb(' + [ '87, 106, 149', '230, 162, 60', '72, 128, 255', ][nodeConfig.type] + ');' ">
            <span class="editable-title">{{ nodeConfig.nodeName }}</span>
            <i class="el-icon-close close" v-if="nodeConfig.type != 0 && !readonly" @click.stop="delNode(nodeConfig)"></i>
          </div>
          <div class="content">
            <!-- 审批人节点文本 -->
            <div class="text" v-if="nodeConfig.type == 1">
              <span class="placeholder" v-if="setApproverStr(nodeConfig) === ''">
                请选择{{ placeholderList[nodeConfig.type] }}
              </span>
              {{ setApproverStr(nodeConfig) }}
            </div>
            <!-- 抄送人节点文本 -->
            <div class="text" v-if="nodeConfig.type == 2">
              <span class="placeholder" v-if="setApproverStr(nodeConfig) === ''">
                请选择{{ placeholderList[nodeConfig.type] }}
              </span>
              {{ setApproverStr(nodeConfig) }}
            </div>
            <i class="el-icon-arrow-right arrow"></i>
          </div>
          <div class="error_tip" v-if="isTried && nodeConfig.error">
            <i class="el-icon-warning" style="color: rgb(242, 86, 67);"></i>
          </div>
        </div>
      </div>
      
      <!-- 添加子节点 -->
      <addNode v-if="!readonly && nodeConfig.type != 2" :childNodeP.sync="nodeConfig.childNode" :isWorkFlowView="isWorkFlowView"></addNode>
      
      <!-- 抄送人节点到流程结束的连接线 -->
      <div v-if="nodeConfig.type == 2" style="width: 100%; display: flex; justify-content: center;">
        <div style="width: 2px; height: 60px; background-color: #cacaca;"></div>
      </div>
    </div>
    
    <!-- 条件分支节点 -->
    <div class="branch-wrap" v-if="nodeConfig.type === 4">
      <div class="branch-box-wrap">
        <div class="branch-box">
          <!-- 添加条件按钮 -->
          <button class="add-branch" v-if="!readonly" @click="addTerm">
            添加条件
          </button>
          
          <!-- 条件分支循环 -->
          <div class="col-box" v-for="(item, index) in nodeConfig.conditionNodes" :key="index">
            <div class="condition-node">
              <div class="condition-node-box">
                <div class="auto-judge" @click="setPerson(item.priorityLevel,item)" :class="isTried && item.error ? 'error active' : '' ">
                  <!-- 向左排序按钮 -->
                  <div class="sort-left" v-if="index !== 0 && !readonly" @click.stop="arrTransfer(index, -1)">
                  </div>
                  <!-- 条件标题 -->
                  <div class="title-wrapper">
                    <span class="editable-title">{{ item.nodeName }}</span>
                    <span class="priority-title">优先级{{ item.priorityLevel }}</span>
                    <i class="el-icon-close close" v-if="!readonly" @click.stop="delTerm(index)"></i>
                  </div>
                  <!-- 向右排序按钮 -->
                  <div class="sort-right" v-if="index !== nodeConfig.conditionNodes.length - 1 && !readonly" @click.stop="arrTransfer(index)"> &gt; </div>
                  <!-- 条件内容 -->
                  <div class="content">
                    {{ conditionStr(item, index) }}
                  </div>
                  <!-- 错误提示 -->
                  <div class="error_tip" v-if="isTried && item.error">
                    <i class="el-icon-warning" style="color: rgb(242, 86, 67);"></i>
                  </div>
                </div>
                <!-- 添加条件分支的子节点 -->
                <addNode v-if="!readonly" :childNodeP.sync="item.childNode" :tip="'条件'" :isWorkFlowView="isWorkFlowView"></addNode>
              </div>
            </div>
            
            <!-- 递归渲染条件分支的子节点 -->
            <nodeWrap v-if="item.childNode && item.childNode" :dataFields="dataFields" :nodeConfig.sync="item.childNode" :isTried.sync="isTried" :readonly="readonly" :isWorkFlowView="isWorkFlowView"></nodeWrap>
            
            <!-- 连接线 -->
            <div class="top-left-cover-line" v-if="index == 0"></div>
            <div class="bottom-left-cover-line" v-if="index == 0"></div>
            <div class="top-right-cover-line" v-if="index == nodeConfig.conditionNodes.length - 1"></div>
            <div class="bottom-right-cover-line" v-if="index == nodeConfig.conditionNodes.length - 1"></div>
          </div>
        </div>
        <!-- 添加分支条件后的子节点 -->
        <addNode v-if="!readonly" :childNodeP.sync="nodeConfig.childNode" :isWorkFlowView="isWorkFlowView"></addNode>
      </div>
    </div>
    
    <!-- 递归渲染子节点 -->
    <nodeWrap v-if="nodeConfig.childNode && nodeConfig.childNode" :dataFields="dataFields" :nodeConfig.sync="nodeConfig.childNode" :isTried.sync="isTried" :readonly="readonly" :isWorkFlowView="isWorkFlowView"></nodeWrap>
    
    <!-- 审批人设置抽屉 -->
    <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="approverWin" width="820px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
      <div slot="title" :style="{'background':'#409eff','color':'white','height':'35px'}">
          <span style="line-height:35px;height:35px;font-size:16px;padding-left:5px;">
            {{ approverConfig.nodeName }}
          </span>
      </div> 
 
      <!-- 审批人设置面板 approverConfig.type == 1 -->
      <div v-if="approverConfig.type == 1">
        <!-- <div style="font-size:12px;font-weight:600;border-left:3px solid #f00;line-height:26px;background:#fcc;padding-left:6px;margin-top:-8px">
          审批节点类型设置：
        </div>
        <div style="font-size:12px;font-weight:600; line-height:30px;margin-top:12px"> 
            <el-radio-group v-model="approverConfig.examineMode" @change="setExamineModeRadio">
              <div v-for="(item,index) in examineList" :key="index" style="line-height:28px">
                <el-radio  :label="item.value"  >{{item.label}} </el-radio>
              </div>
            </el-radio-group>
        </div> -->
        <div v-if="approverConfig.examineMode!=='3'">
          <div style="font-size:12px;font-weight:600;border-left:3px solid #f00;line-height:26px;background:#fcc;padding-left:6px;">
            请设置审批用户
          </div>
          <div style="display:flex;margin-top:-10px" >
            <div style="width:430px;overflow-y:auto; height:550px;margin-top:10px">
              <el-table  :data="tabData" 
                      border                            
                      disabled-hover
                      class="custom-table-border"
                      style="overflow:auto;margin-top:1px;"
                      size="small"
                      :cell-style="{padding:'2px','font-size':'12px',color:'black'}"
                      :row-key="getRowKey" 
                      height="100%" 
                      header-cell-class-name="clearPadding"
                      ref="tabref" 
                      highlight-current-row>
                  <el-table-column label="序号" type="index" width="50" fixed align="center">
                      <el-table-column label="序号" type="index" width="50" align="center" fixed>
                          <template slot="header"  >
                              <el-link   @click="rowShow" style="font-size:12px;color:#404eff;text-align:center; "> 
                                  <el-tooltip content=" 清除条件" effect="light">
                                      <i class="iconfont icon-shanchu1"  ></i>
                                  </el-tooltip>
                              </el-link>
                          </template>
                      </el-table-column>
                  </el-table-column>
                  <el-table-column   v-for="(item,index ) in tabArr.filter(item=>item.thide=='N')" :key="index"
                      :prop="item.key"
                      :label="item.title"
                      show-overflow-tooltip
                      :align="item.align"  
                      :fixed="item.fix=='Y'" 
                      resizable                              
                      :sortable="item.sortable=='N'&&item.edcss!=='checkbox'"
                      :min-width="item.width">
                      <el-table-column  resizable :align="item.align"  :prop="item.key" :label="item.title" show-overflow-tooltip :min-width="item.width">
                          <template slot="header" slot-scope="scope">
                              {{scope.row}}
                              <el-date-picker v-if="item.edcss=='date'" @change="inputQry" size="mini"  type="date" clearable v-model="v_row[item.key]"  value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker> 
                              <el-input type="number" placeholder="数字框" clearable @keyup.enter.native="inputQry" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-else-if="item.edcss=='number'" size="mini" v-model="v_row[item.key]" style="width:100%"> </el-input> 
                              <el-input :disabled="item.edcss=='image'" clearable v-else @keyup.enter.native="inputQry"  v-model="v_row[item.key]" size="mini" placeholder="请输入" ></el-input> 
                          </template>
                          <template slot-scope="scope">
                              <el-checkbox v-if="item.edcss=='checkbox'" disabled true-label="Y"  false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                              <el-tag  v-else-if="item.key=='STFG'&&scope.row['STFG']=='Y'" size="mini" type="success" effect="dark">已审核</el-tag>
                              <el-tag  v-else-if="item.key=='STFG'&&scope.row['STFG']=='N'" size="mini" type="info" effect="dark">未审核</el-tag>                         
                              <span v-else v-text="scope.row[item.key]" ></span>
                          </template>
                      </el-table-column>               
                  </el-table-column>   
                  <el-table-column
                      fixed="right"
                      label="操作"
                      align="center"
                      width="75">
                      <template slot-scope="scope">
                          <i class="iconfont icon-chenggong" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                          <el-link  @click="editRec(scope.row )" :underline="false"  ><span style="font-size:12px;margin-right:6px;">选中</span></el-link>
                      </template>
                  </el-table-column>                
                </el-table> 
            </div>
            <div style="min-width:350px; height:30px;margin-top:10px; background:#808695;border-left:2px solid #409eff;font-size:12px;line-height:30px;color:#fff;font-weight:600;padding-left:5px"> 
                已选择列表               
                <el-checkbox true-label="Y" false-label="N" v-model="v_uchk" @change="userSel" style="margin-left:10px;" ><span style="color:white;font-size:12px;">全选</span></el-checkbox>
                <el-link :underline="false" @click="delUser" style="color:white;font-size:12px;margin-left:10px;float:right;margin-right:8px "><i class="iconfont icon-shanchu1" style="margin-right:3px"></i>删除选中记录</el-link>              
              <div style="width:400px;overflow-y:auto; height:520px;margin-top:1px; border:1px solid #ccc;margin-left:-7px">
                <div v-for="(item,index) in userList" :key="index" style="line-height:26px;font-size:12px" >
                  <div style="display:flex; ">
                    <div style="margin-left:5px;font-weight:600;font-size:14px;color:black;min-width:120px; ">
                    <el-checkbox true-label="Y" false-label="N" v-model="item['CHK']" style="margin-left:4px"> {{item['EMPNM'] }}</el-checkbox>
                    </div>
                    <div style="margin-left:15px;font-weight:600;font-size:14px;color:black">{{item['DEPTNM']}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
        <!-- 发起人设置面板 approverConfig.type == 0 -->
      <!-- 抄送人设置面板 v-if="approverConfig.type == 2"-->
      <div v-if="approverConfig.type == 2">
          <div style="font-size:12px;font-weight:600;border-left:3px solid #f00;line-height:26px;background:#fcc;padding-left:6px;margin-top:-9px">
            请设置抄送用户
          </div>
          <div style="display:flex;margin-top:-10px" >
            <div style="width:420px;overflow-y:auto; height:550px;margin-top:10px">
              <el-table  :data="tabData" 
                      border                            
                      disabled-hover
                      class="custom-table-border"
                      style="overflow:auto;margin-top:1px;"
                      size="small"
                      :cell-style="{padding:'2px'}"
                      :row-key="getRowKey" 
                      height="100%" 
                      header-cell-class-name="clearPadding"
                      ref="tabref" 
                      highlight-current-row>
                  <el-table-column label="序号" type="index" width="50" fixed align="center">
                      <el-table-column label="序号" type="index" width="50" align="center" fixed>
                          <template slot="header"  >
                              <el-link   @click="rowShow" style="font-size:12px;color:#404eff;text-align:center; "> 
                                  <el-tooltip content=" 清除条件" effect="light">
                                      <i class="iconfont icon-shanchu1"  ></i>
                                  </el-tooltip>
                              </el-link>
                          </template>
                      </el-table-column>
                  </el-table-column>
                  <el-table-column   v-for="(item,index ) in tabArr.filter(item=>item.thide=='N')" :key="index"
                      :prop="item.key"
                      :label="item.title"
                      show-overflow-tooltip
                      :align="item.align"  
                      :fixed="item.fix=='Y'" 
                      resizable                              
                      :sortable="item.sortable=='N'&&item.edcss!=='checkbox'"
                      :min-width="item.width">
                      <el-table-column  resizable :align="item.align"  :prop="item.key" :label="item.title" show-overflow-tooltip :min-width="item.width">
                          <template slot="header" slot-scope="scope">
                              {{scope.row}}
                              <el-date-picker v-if="item.edcss=='date'" @change="inputQry" size="mini"  type="date" clearable v-model="v_row[item.key]"  value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker> 
                              <el-input type="number" placeholder="数字框" clearable @keyup.enter.native="inputQry" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-else-if="item.edcss=='number'" size="mini" v-model="v_row[item.key]" style="width:100%"> </el-input> 
                              <el-input :disabled="item.edcss=='image'" clearable v-else @keyup.enter.native="inputQry"  v-model="v_row[item.key]" size="mini" placeholder="请输入" ></el-input> 
                          </template>
                          <template slot-scope="scope">
                              <el-checkbox v-if="item.edcss=='checkbox'" disabled true-label="Y"  false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                              <el-tag  v-else-if="item.key=='STFG'&&scope.row['STFG']=='Y'" size="mini" type="success" effect="dark">已审核</el-tag>
                              <el-tag  v-else-if="item.key=='STFG'&&scope.row['STFG']=='N'" size="mini" type="info" effect="dark">未审核</el-tag>                         
                              <span v-else v-text="scope.row[item.key]" ></span>
                          </template>
                      </el-table-column>               
                  </el-table-column>   
                  <el-table-column
                      fixed="right"
                      label="操作"
                      align="center"
                      width="75">
                      <template slot-scope="scope">
                          <i class="iconfont icon-chenggong" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                          <el-link  @click="editRec(scope.row )" :underline="false"  ><span style="font-size:12px;margin-right:6px;">选中 </span></el-link>
                      </template>
                  </el-table-column>                
                </el-table> 
            </div>
            <div style="min-width:350px; height:30px;margin-top:10px; background:#808695;border-left:2px solid #409eff;font-size:12px;line-height:30px;color:#fff;font-weight:600;padding-left:5px"> 
                已选择列表               
                <el-checkbox true-label="Y" false-label="N" v-model="v_uchk" @change="userSel" style="margin-left:10px;"><span style="color:white;font-size:12px; ">全选</span> </el-checkbox>
                <el-link :underline="false" @click="delUser" style="color:white;font-size:12px;margin-left:10px;float:right;margin-right:8px "><i class="iconfont icon-shanchu1" style="margin-right:3px"></i>删除选中记录</el-link>              
              <div style="width:400px;overflow-y:auto; height:520px;margin-top:1px; border:1px solid #ccc;margin-left:-7px">
                <div v-for="(item,index) in userList" :key="index" style="line-height:26px;font-size:12px" >
                  <div style="display:flex; ">
                    <div style="margin-left:5px;font-weight:600;font-size:14px;color:black;min-width:120px; ">
                    <el-checkbox true-label="Y" false-label="N" v-model="item['CHK']" style="margin-left:4px"> {{item['EMPNM'] }}</el-checkbox>
                    </div>
                    <div style="margin-left:15px;font-weight:600;font-size:14px;color:black">{{item['DEPTNM']}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>  
      <!-- 条件设置面板 approverConfig.type == 3 -->
      <div v-if="approverConfig.type == 3">
          <div style="font-size:12px;font-weight:600;border-left:3px solid #f00;line-height:26px;background:#fcc;padding-left:6px;margin-top:-9px">
            请设置条件 
            <el-button type="info" size="mini" @click="addConditionGroup('0')" style="margin-left:15px;font-size:12px;  ">
             <i class="iconfont icon-xinzeng"></i> 添加条件组
            </el-button>
          </div>
          <div style="height:520px ;overflow-y:auto" >
           <div v-for="(item, index) in approverConfig.conditionList" :key="index">
              <!-- 条件表达式设置 -->
              <div style="line-height:30px;height:35px;margin-bottom:5px" v-for="(it, ind) in item.conditionChildrenNodes" :key="ind" >
                <!-- 左操作数 -->
                <div style="display:flex;margin-top:6px">
                    <el-select size="medium" style="width:200px" v-model="it.leftFileds" placeholder="请选择" @change="dataFieldsChange(it)">
                      <el-option v-for="item in dataFields" :label="item.name" :value="item.key" :key="item.key"></el-option>
                    </el-select>
            
                    <!-- 操作符 -->        
                    <el-select size="medium" style="width:80px" v-model="it.centerFileds" placeholder="请选择">
                      <el-option v-for="item in operatorList" :label="item" :value="item" :key="item"></el-option>
                    </el-select>
        
                    <!-- 右操作数 -->        
                    <el-input type="number" size="medium"  v-if="it.leftFiledsType === 'number'" v-model="it.rightFileds" style="width:200px" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"></el-input>  
                    <el-input v-else v-model="it.rightFileds" style="width:200px" size="medium" placeholder="请输入"></el-input>
                    <div v-if="ind>0" style="margin-left:15px;line-height:30px;margin-top:3px">
                      <el-link :underline="false" @click="removeCondition(index,ind)"><i class="iconfont icon-shanchu1"></i></el-link>
                    </div>
                </div>
              </div>
              <!-- 添加条件按钮 -->
              <div style="margin-top:10px;">
                <el-button type="danger" plain size="mini" @click="addConditionGroup('1', item)">
                  <i class="el-button-suffix el-icon-plus"></i>添加条件
                </el-button>
              </div>
           </div>
          </div> 
      </div>  
      <!-- 底部按钮 -->
      <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; " >
        <span style="float:right">
          <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="approverWin=false" style="margin-right:25px;">取消</el-button>
          <el-button    type="primary" size="small" icon="iconfont icon-baocun"  @click="saveApprover" style="margin-right:10px;">保存</el-button>
        </span>
      </div>
    </el-dialog>
    <!-- 发起人选择窗口-->
    <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="startWin" width="805px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
      <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
          <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">
            {{ approverConfig.nodeName }}
          </span>
      </div> 
      <div style="font-size:12px;font-weight:600;border-bottom:2px solid #389;line-height:30px">请选择：
          <el-radio-group v-model="v_start" @change="setTypeRadio">
            <el-radio label="ALL">所有人</el-radio>
            <el-radio label="DEPT">指定部门</el-radio>
            <el-radio label="USER">指定用户</el-radio>
          </el-radio-group>
      </div>
      <div v-if="v_start=='ALL'" style="width:400px;overflow-y:auto; height:550px;margin-top:10px"></div>
      <div style="display:flex" v-if="v_start=='DEPT'">
          <div style="width:350px;overflow-y:auto; height:550px;margin-top:10px">
            <el-input placeholder="请输入关键字进行过滤" v-model="filterText" size="medium" clearable  ></el-input> 
            <el-tree :data="orgData" 
                        :props="defaultProps" 
                        @node-click="handleNodeClick" 
                        node-key="id"                       
                        :style="{height:'93%', overflow:'auto',display: 'flex',border:'1px solid #ccc'}"
                        highlight-current
                        :filter-node-method="filterNode"
                        ref="eltree"
                        default-expand-all
                        :expand-on-click-node="false">
                <template v-slot="{node,data}">                                     
                    <span v-if="data.id ==0 "  class="nodeRoot" >                     
                     <span  style="font-size:14px; color:#409efe"><i class="iconfont   icon-kucunguanli" style="color:#409eff;font-size:18px;"></i>{{ node.label}} </span>
                    </span>                  
                    <span v-else > 
                        <span style="color:#2b85e4;font-size:12px;"><i class="iconfont icon-fenzhijiedian" style="color:#409eff;font-size:14px;"></i> {{ node.label}} </span>
                    </span>
                </template>
            </el-tree>
          </div>
          <div style="width:50px;overflow-y:auto; height:550px;margin-top:10px; background:#f7f8f9">
 
          </div>
          <div style="width:400px; height:30px;margin-top:10px; background:#808695;border-left:2px solid #409eff;font-size:12px;line-height:30px;color:#fff;font-weight:600;padding-left:5px"> 
              已选择列表 
              
              <el-checkbox true-label="Y" false-label="N" v-model="v_check" @change="allSel" style="margin-left:10px;"><span style="color:white;font-size:12px; ">全选</span></el-checkbox>
              <el-link :underline="false" @click="delDept" style="color:white;font-size:12px;margin-left:10px;float:right;margin-right:8px "><i class="iconfont icon-shanchu1" style="margin-right:3px"></i>删除选中记录</el-link>
             
             <div style="width:400px;overflow-y:auto; height:520px;margin-top:1px; border:1px solid #ccc;margin-left:-7px">
               <div v-for="(item,index) in fromList" :key="index" style="line-height:26px;font-size:12px" >
                 <div style="display:flex">
                   <el-checkbox true-label="Y" false-label="N" v-model="item['CHK']" style="margin-left:4px"> {{item['CNAME'] }}</el-checkbox>
                  
                 </div>
               </div>
             </div>
          </div>
      </div>
      <div style="display:flex" v-if="v_start=='USER'">
          <div style="width:420px;overflow-y:auto; height:550px;margin-top:10px">
             <el-table  :data="tabData" 
                    border                            
                    disabled-hover
                    class="custom-table-border"
                    style="overflow:auto;margin-top:1px;"
                    size="small"
                    :cell-style="{padding:'2px'}"
                    :row-key="getRowKey" 
                    height="100%" 
                    header-cell-class-name="clearPadding"
                    ref="tabref" 
                    highlight-current-row>
                <el-table-column label="序号" type="index" width="50" fixed align="center">
                    <el-table-column label="序号" type="index" width="50" align="center" fixed>
                        <template slot="header"  >
                            <el-link   @click="rowShow" style="font-size:12px;color:#404eff;text-align:center; "> 
                                <el-tooltip content=" 清除条件" effect="light">
                                    <i class="iconfont icon-shanchu1"  ></i>
                                </el-tooltip>
                            </el-link>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column   v-for="(item,index ) in tabArr.filter(item=>item.thide=='N')" :key="index"
                    :prop="item.key"
                    :label="item.title"
                    show-overflow-tooltip
                    :align="item.align"  
                    :fixed="item.fix=='Y'" 
                    resizable                              
                    :sortable="item.sortable=='N'&&item.edcss!=='checkbox'"
                    :min-width="item.width">
                    <el-table-column  resizable :align="item.align"  :prop="item.key" :label="item.title" show-overflow-tooltip :min-width="item.width">
                        <template slot="header" slot-scope="scope">
                            {{scope.row}}
                            <el-date-picker v-if="item.edcss=='date'" @change="inputQry" size="mini"  type="date" clearable v-model="v_row[item.key]"  value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker> 
                            <el-input type="number" placeholder="数字框" clearable @keyup.enter.native="inputQry" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-else-if="item.edcss=='number'" size="mini" v-model="v_row[item.key]" style="width:100%"> </el-input> 
                            <el-input :disabled="item.edcss=='image'" clearable v-else @keyup.enter.native="inputQry"  v-model="v_row[item.key]" size="mini" placeholder="请输入" ></el-input> 
                        </template>
                        <template slot-scope="scope">
                            <el-checkbox v-if="item.edcss=='checkbox'" disabled true-label="Y"  false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                            <el-tag  v-else-if="item.key=='STFG'&&scope.row['STFG']=='Y'" size="mini" type="success" effect="dark">已审核</el-tag>
                            <el-tag  v-else-if="item.key=='STFG'&&scope.row['STFG']=='N'" size="mini" type="info" effect="dark">未审核</el-tag>                         
                            <span v-else v-text="scope.row[item.key]" ></span>
                        </template>
                    </el-table-column>               
                </el-table-column>   
                <el-table-column
                    fixed="right"
                    label="操作"
                    align="center"
                    width="75">
                    <template slot-scope="scope">
                        <i class="iconfont icon-chenggong" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link  @click="editRec(scope.row )" :underline="false"  ><span style="font-size:12px;margin-right:6px;">选中 </span></el-link>
                    </template>
                </el-table-column>                
              </el-table> 
          </div>
          <div style="width:10px;overflow-y:auto; height:550px;margin-top:10px; background:#f7f8f9">
 
          </div>
          <div style="min-width:370px;max-width:100%; height:30px;margin-top:10px; background:#808695;border-left:2px solid #409eff;font-size:12px;line-height:30px;color:#fff;font-weight:600;padding-left:5px"> 
              已选择列表               
              <el-checkbox true-label="Y" false-label="N" v-model="v_uchk" @change="userSel" style="margin-left:10px;"><span style="color:white;font-size:12px; ">全选</span></el-checkbox>
              <el-link :underline="false" @click="delUser" style="color:white;font-size:12px;margin-left:10px;float:right;margin-right:8px "><i class="iconfont icon-shanchu1" style="margin-right:3px"></i>删除选中记录</el-link>
             
             <div style="width:400px;overflow-y:auto; height:520px;margin-top:1px; border:1px solid #ccc;margin-left:-7px">
               <div v-for="(item,index) in userList" :key="index" style="line-height:26px;font-size:12px" >
                 <div style="display:flex; ">
                   <div style="margin-left:5px;font-weight:600;font-size:14px;color:black;min-width:120px; ">
                   <el-checkbox true-label="Y" false-label="N" v-model="item['CHK']" style="margin-left:4px"> {{item['EMPNM'] }}</el-checkbox>
                   </div>
                   <div style="margin-left:15px;font-weight:600;font-size:14px;color:black">{{item['DEPTNM']}}</div>
                 </div>
               </div>
             </div>
          </div>
      </div>
      <!-- 底部按钮 -->
      <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; " >
        <span style="float:right">
          <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="startWin=false" style="margin-right:25px;">取消</el-button>
          <el-button    type="primary" size="small" icon="iconfont icon-baocun"  @click="saveStart" style="margin-right:10px;">保存</el-button>
        </span>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="promptWin" v-dialogDrag width="450px" append-to-body :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
        <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
            <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
        </div> 
        <div style="line-height:30px;display:flex">
            <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
            <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
        </div>
        <span slot="footer"  >
            <el-button size="small" type="primary" @click="promptWin = false">确 定</el-button>
        </span>
    </el-dialog>
  </div>
</template>
<script>
import addNode from './addNode'
 
export default {
  name: 'nodeWrap',
  components: { addNode,},
 
  props: {
    nodeConfig: {
      type: Object,
      required: true
    },
    isTried: {
      type: Boolean,
      default: false
    },
    dataFields: {
      type: Array,
      default: () => []
    },
    readonly: {
      type: Boolean,
      default: false
    },
    isWorkFlowView: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      v_start:'ALL' ,
      fromList:[],
      tabArr:[],
      tabData:[],
      placeholderList: ['发起人', '审核人', '抄送人'],
 
      //审批弹框字段Obj
      approverConfig: {
        titleInputFlag: false,
        nodeName: '',
        type: 0,
        nodeUserType: {
          type: 'user',
          value: '',
          valueName: '',
          valueList: []
        },
        examineMode: '1',
        conditionList: []
      },
      promptWin:false,
      prompt:'',
      directorLevel: '1', //主管层级
      nodeUser: '', //审批人（stringList）
      approverWin: false, //审批弹框
      conditionDrawer: false, //条件弹框
      //条件弹框字段
      conditionsConfig: {},
      conditionConfig: {}, //条件弹框item
      useroptions: [
        { name: "admin", id: "1", userName: "admin" },
        { name: "Anna", id: "2", userName: "Anna" },
      ],
      userInfo: {
        data: [],
        total: 0
      },
      examineList: [{
        value: '1',
        label: '会签审批（需要所有审批人同意，该审批节点才通过）',
 
      },
      {
        value: '2',
        label: '或签审批（任意一名审批人同意，该审批节点即通过）',
 
      },
      // {
      //   value: '3',
      //   label: '逐级审批（按人事部门层级逐级依次审批后，该审批节点才通过）',
      // },
      ],
      operatorList: ['=', '!=', '>', '>=', '<', '<='],
      v_check:'N' ,
      v_uchk:'N',
      isInputList: [],
      isInput: false,
      hasFlag: false,
      conditionTip: '',
      bPriorityLevel: '',
      conditionList: [],
      filterText:'',
      selectionList: [], //表格选中id
      nodeLabel:'',
      nodeId:'',
      startWin: false,
      valueSponsor: [],
      dataSponsor: [],
      v_username:this.$cookies.get('v_telno'), //api 请求用户
      
      v_url:'xuper_auth/getBaseData', //动态请求url接口
      departments: {
        titleDepartments: [],
        childDepartments: [],
        employees: []
      },
      roles: [],
      total: 0,
      v_corpid:this.$cookies.get('v_corpid') , //员工公司ID
      checkedEmployeesList: [],
      userList: [],
      checkedDepartmentList: [],
      defaultProps: {  //el-tree 默认字段属性
          children: 'children',
          id:'id',
          icon:'icon',
          parentid:'',
          label: 'label'
      },
      orgData:[] , 
      v_row:{},
      deletedNodeIds: [], // 新增的deletedNodeIds数组
    }
  },
  watch: {
 
    filterText(val) {
        this.$refs.eltree.filter(val);
    }
  },

  computed: {
    scrollerHeight: function() {
        return (window.innerHeight - 40) + 'px';
    },
  },
  created() {
    // 初始化数据
    this.getTabField()
    this.inputQry()
  },
  mounted() {
    // 加载部门数据
    this.getDept()

    // 确保发起人节点有nodeUserType对象
    if (this.nodeConfig.type == 0) {
      // 如果nodeUserType不存在，初始化它
      if (!this.nodeConfig.nodeUserType) {
        this.$set(this.nodeConfig, 'nodeUserType', {
          type: 'ALL', // 默认为所有人
          value: '',
          valueName: '所有人',
          valueList: []
        });
      }
      
      // 如果nodeUserType存在但type为空，设置为ALL
      else if (!this.nodeConfig.nodeUserType.type) {
        this.$set(this.nodeConfig.nodeUserType, 'type', 'ALL');
        if (!this.nodeConfig.nodeUserType.valueName || this.nodeConfig.nodeUserType.valueName.trim() === '') {
          this.$set(this.nodeConfig.nodeUserType, 'valueName', '所有人');
        }
      }
      
      this.nodeConfig.error = this.setApproverStr(this.nodeConfig) == ''
    } else if (this.nodeConfig.type == 1) {
      if (!this.nodeConfig.nodeUserType) {
        this.$set(this.nodeConfig, 'nodeUserType', {
          type: '',
          value: '',
          valueName: '',
          valueList: []
        });
      }
      this.nodeConfig.error = this.setApproverStr(this.nodeConfig) == ''
    } else if (this.nodeConfig.type == 2) {
      if (!this.nodeConfig.nodeUserType) {
        this.$set(this.nodeConfig, 'nodeUserType', {
          type: '',
          value: '',
          valueName: '',
          valueList: []
        });
      }
      this.nodeConfig.error = this.setApproverStr(this.nodeConfig) === ''
    } else if (this.nodeConfig.type == 4) {
      for (var i = 0; i < this.nodeConfig.conditionNodes.length; i++) {
        this.nodeConfig.conditionNodes[i].error =
          this.conditionStr(this.nodeConfig.conditionNodes[i], i) ==
          '请设置条件'
      }
    }
  },
  methods: {
    //删除条件组和条件
    removeCondition( index, ind) {
      this.approverConfig.conditionList[index].conditionChildrenNodes.splice(ind, 1)
    },
    editRec( row ){
        // 检查是否是审核人节点（type == 1），如果是则只能选择一个
        if (this.approverConfig.type == 1) {
          // 审核人只能选择一个，先清空现有选择
          this.userList = [];
          // 添加新选择的用户
          this.userList.push({
            CHK: 'N',
            EMPNM: row['EMPNM'],
            EMPNO: row['IDNO'],
            DEPTNM: row['DEPTNM'],
            IDSEQ: row['IDSEQ']
          });
        } else {
          // 抄送人可以选择多个，保持原逻辑
          let exists = false;
          let existingIndex = -1;
          
          for (let i = 0; i < this.userList.length; i++) {
            if (this.userList[i]['EMPNO'] == row['IDNO']) {
              exists = true;
              existingIndex = i;
              break;
            }
          }
          
          if (!exists) {
            // 添加新用户，确保保留部门信息
            this.userList.push({
              CHK: 'N',
              EMPNM: row['EMPNM'],
              EMPNO: row['IDNO'],
              DEPTNM: row['DEPTNM'],
              IDSEQ: row['IDSEQ']
            });
          } else {
            // 可选：提示用户已存在
            this.$message.info(`用户 ${row['EMPNM']} 已在选择列表中`);
          }
        }
    },
 
    //字段查询
    inputQry(){
        let  v_edcss='' , v_cond =''
        Object.keys(this.v_row).forEach(item=>{
            if (this.v_row[item] ){
                this.tabArr.some(it=>{
                    if (it['key']== item){
                        v_edcss =it['edcss']
                    }
                })
                if (v_cond ){
                    if (v_edcss =='number'){
                        v_cond =v_cond +' and '+item+'>='+  this.v_row[item] 
                    }else{
                        v_cond =v_cond +' and lower('+item+') like \'%'+ (this.v_row[item]).toLowerCase().trim()+'%\''
                    }
                }else{
                    if (v_edcss =='number'){
                        v_cond = ' and '+item+'>='+  this.v_row[item] 
                    }else{
                        v_cond = ' and lower('+item+') like \'%'+ (this.v_row[item]).toLowerCase().trim()+'%\''
                    }
                }
            }
        })
        this.getTabList( v_cond)
    },
    rowShow(){
        Object.keys(this.v_row).forEach(item=>{
            this.v_row[item] =''
        })
        this.getTabList('')
    } ,
    getTabList(cond){
        //获取所有产品记录且初始化分页记录  
        let v_table='V_hr_emp'    
        if (this.v_corpid=='300') { //如果是金骁账套时，则查询员工包含速珀管理员，包含所有子公司的员工数据
           v_table='V_HR_EMP_JX'
    
        }
        this.$axios({   
            method: 'post',
            url:this.v_url,
            data: { p_cond:cond ,p_table:v_table,p_key:'corpid',p_value:this.v_corpid,p_key2:'stfg',p_value2:'Y' },
        }).then(res=>{ 
            if (res.code==='200'){
                this.tabData =res.result 
            }else{
                this.promptWin=true
                this.prompt=res.result
            }
 
        }) 
    },
    getRowKey(row){
        return row.IDSEQ
    },
    
    // 收集所有被删除节点的ID
    collectDeletedNodeIds() {
      if (this.deletedNodeIds && this.deletedNodeIds.length > 0) {
        return [...this.deletedNodeIds];
      }
      return [];
    },
    
    // 向父组件传递已删除节点ID
    emitDeletedNodeIds() {
      if (this.deletedNodeIds && this.deletedNodeIds.length > 0) {
        this.$emit('nodes-deleted-batch', [...this.deletedNodeIds]);
      }
    },
    
    // 递归收集节点及其子节点的IDSEQ
    collectNodeAndChildrenIds(node, idsArray) {
      if (!node) return;
      
      // 收集当前节点ID
      if (node.IDSEQ && !idsArray.includes(node.IDSEQ)) {
        idsArray.push(node.IDSEQ);
      }
      
      // 递归收集子节点ID
      if (node.childNode) {
        this.collectNodeAndChildrenIds(node.childNode, idsArray);
      }
      
      // 递归收集条件节点ID
      if (node.conditionNodes && node.conditionNodes.length > 0) {
        node.conditionNodes.forEach(condNode => {
          if (condNode.IDSEQ && !idsArray.includes(condNode.IDSEQ)) {
            idsArray.push(condNode.IDSEQ);
          }
          if (condNode.childNode) {
            this.collectNodeAndChildrenIds(condNode.childNode, idsArray);
          }
        });
      }
    },
    
    allSel(){
      if (this.v_check=='Y'){
         this.fromList.forEach(item=>{
           item['CHK'] ='Y'
         })
      }else {
         this.fromList.forEach(item=>{
           item['CHK'] ='N'
         })
      }
    },
    // 删除选中的 部门
    delDept(){
      let v_ind =[]
      this.fromList.forEach((item,index) =>{
        if (item['CHK']=='Y'){
          v_ind.push(JSON.parse(JSON.stringify(item)))
        }
      })
      if (v_ind.length >0) {
        v_ind.forEach(item=>{
          let v_index =this.fromList.findIndex(it=>it['CNAME']==item['CNAME'])
          this.fromList.splice(v_index,1)
        })
        this.v_check ='N'
      }else {
         this.$message.error('请选择行记录')
      }
    },
    userSel(){
      if (this.v_uchk=='Y'){
         this.userList.forEach(item=>{
           item['CHK'] ='Y'
         })
      }else {
         this.userList.forEach(item=>{
           item['CHK'] ='N'
         })
      }
    },
 
    //删除选中的员工
    delUser(){
      let v_ind =[]
      this.userList.forEach((item,index) =>{
        if (item['CHK']=='Y'){
          v_ind.push(JSON.parse(JSON.stringify(item)))
        }
      })
      if (v_ind.length >0) {
        v_ind.forEach(item=>{
          let v_index =this.userList.findIndex(it=>it['EMPNO']==item['EMPNO'])
          this.userList.splice(v_index,1)
        })
        this.v_uchk ='N'
      }else {
         this.$message.error('请选择行记录')
      }
    },
 
    getDept() {   
        var vm=this;
        this.$axios({
            method: 'post',
            url: 'xuper_auth/getElTreeData',
            data: {p_table:'V_hr_FRAME',p_cond:' and ( corpid=\''+this.v_corpid+'\')'}
        }).then(function(res){ 
            if (res.code==='200'){                 
                vm.orgData =res.result;  
            } else{
                vm.promptWin=true
                vm.prompt=res.result
            }            
        })                             
    },
    //节点点击
    handleNodeClick(data){
        this.nodeLabel=data.label          
        this.nodeId =data.id 
        if (data.id =='0'){
          //
        }else{
          let v_bool =true
          this.fromList.some(item=>{
            if (item['ID']  ==data.id){
              v_bool =false
            }
          })
          if (v_bool) {
            this.fromList.push ({CHK:'N',CNAME:data.label,ID:data.id})
          }
        }
    },
    //节点过滤
    filterNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
    },
 
    selectionChange(val) {
      this.selectionList = val.map(item => item.id);
    },
    saveUserInfo() {
      this.approverConfig.nodeUserType.valueList = this.selectionList;
      // this.dialogFlag = false;
    },
 
    //审批选择节点
    setExamineModeRadio(val) {
      this.$set(this.approverConfig.nodeUserType, 'value', '')
      this.$set(this.approverConfig.nodeUserType, 'valueList', [])
      if (val === '3') {
        this.approverConfig.nodeUserType.type = 'manager'
      }
    },
    //添加条件组
    addConditionGroup(flag, item) {
      if (flag === '1') {
        item.conditionChildrenNodes.push({
          leftFileds: '',
          centerFileds: '=',
          rightFileds: '',
        })
        return
      }
      if (this.approverConfig.conditionList.length ==0 && flag==0) {
        this.approverConfig.conditionList.push({
          conditionChildrenNodes: [{
            leftFileds: '',
            centerFileds: '=',
            rightFileds: '',
          }],
          conditionGroupOperator: '',
        })
      }
    },
    //节点类型
    setTypeRadio(val) {
      
      // 清除已有数据
      if (this.approverConfig.nodeUserType.valueList && this.approverConfig.nodeUserType.valueList.length > 0) {
        this.approverConfig.nodeUserType.valueList = []
      }
      
      // 特殊处理ALL类型
      if (val === 'ALL') {
        this.$set(this.approverConfig.nodeUserType, 'type', 'ALL');
        this.$set(this.approverConfig.nodeUserType, 'valueName', '所有人');
        this.$set(this.approverConfig.nodeUserType, 'value', '');
        this.$set(this.approverConfig.nodeUserType, 'valueList', []);
      } else {
        // 清除数据
        this.approverConfig.nodeUserType.valueName = '';
        this.approverConfig.nodeUserType.value = '';
      }
    },
    //修改节点name
    editNodename() {
      this.$set(this.approverConfig, 'titleInputFlag', true)
    },
    nodeNameBlur() {
      this.$set(this.approverConfig, 'titleInputFlag', false)
    },
    //条件显示
    conditionStr(item, index) {
      let {
        conditionList, //条件组
        conditionString, //条件数据
        conditionStringName, //条件显示
      } = item
      let arr = [true] //判断条件是否有值
      if (conditionList.length === 0 || conditionString === '') {
        return '请设置条件'
      }
      if (conditionList.length !== 0) {
 
        if (conditionList.length === 1) {
          //当条件组为一个
          conditionList[0].conditionChildrenNodes &&
            conditionList[0].conditionChildrenNodes.forEach(
              (item, index) => {
                if (item.leftFileds == '' || item.centerFileds == '' || item.rightFileds == '') {
                  arr.push(false)
                }
              
              }
            )
        } else {
          //当条件组为多个（判断是否有运算符）
          conditionList.forEach((item, index) => {
            if (item.conditionChildrenNodes && item.conditionChildrenNodes.length > 0) {
              item.conditionChildrenNodes.forEach((it, ind) => {
                if (
                  it.leftFileds === '' ||
                  it.centerFileds === '' ||
                  it.rightFileds == ''
                )
                  arr.push(false)
               
                })
            } else if (
              item.conditionChildrenNodes &&
              item.conditionChildrenNodes.length == 0
            ) {
              arr.push(false)
            }
          })
        }
        if (arr.includes(false)) {
          return '请设置条件'
        }
      }
 
      // 移除可能存在的 null 字符串
      return (conditionStringName || '').replace(/null/g, '')
    },
    dealStr(str, obj) {
      let arr = []
      let list = str.split(',')
      for (var elem in obj) {
        list.map((item) => {
          if (item == elem) {
            arr.push(obj[elem].value)
          }
        })
      }
      return arr.join('或')
    },
    // 发起人 回显
    setStart() {
      if (this.nodeConfig.type==0) {
        // 使用正确的对话框变量
        this.startWin = true;
        this.approverConfig = JSON.parse(JSON.stringify(this.nodeConfig));
        
        // 根据nodeUserType.type初始化v_start
        if (this.nodeConfig.nodeUserType && this.nodeConfig.nodeUserType.type) {
          this.v_start = this.nodeConfig.nodeUserType.type;
          
          // 如果是DEPT类型，初始化fromList
          if (this.nodeConfig.nodeUserType.type === 'DEPT' && this.nodeConfig.nodeUserType.valueList) {
            this.fromList = [];
            const valueList = this.nodeConfig.nodeUserType.valueList;
            const valueNames = this.nodeConfig.nodeUserType.valueName ? this.nodeConfig.nodeUserType.valueName.split(',') : [];
            
            for (let i = 0; i < valueList.length; i++) {
              this.fromList.push({
                CHK: 'N',
                ID: valueList[i],
                CNAME: valueNames[i] || valueList[i]
              });
            }
          }
          
          // 如果是USER类型，初始化userList
          if (this.nodeConfig.nodeUserType.type === 'USER' && this.nodeConfig.nodeUserType.valueList) {
            this.userList = [];
            const valueList = this.nodeConfig.nodeUserType.valueList;
            const valueNames = this.nodeConfig.nodeUserType.valueName ? this.nodeConfig.nodeUserType.valueName.split(',') : [];
            
            for (let i = 0; i < valueList.length; i++) {
              this.userList.push({
                CHK: 'N',
                EMPNO: valueList[i],
                EMPNM: valueNames[i] || valueList[i],
                DEPTNM: ''
              });
            }
          }
        } else {
          // 默认设置为ALL
          this.approverConfig.nodeUserType.type = 'ALL';
          this.approverConfig.nodeUserType.value = '';  // 可以为空
          this.approverConfig.nodeUserType.valueList = [];  // 空数组
          return `由：所有人 发起`
        }
      }
    },
    //保存 发起人
    saveStart() {
      this.startWin = false
      
      // 确保nodeUserType对象存在
      if (!this.approverConfig.nodeUserType) {
        this.approverConfig.nodeUserType = {
          type: '',
          value: '',
          valueName: '',
          valueList: []
        };
      }
      
      // 根据v_start设置正确的type
      this.approverConfig.nodeUserType.type = this.v_start;
      
      // 如果是ALL，设置为所有人
      if (this.v_start === 'ALL') {
        // 完整设置所有字段
        this.approverConfig.nodeUserType = {
          type: 'ALL',
          value: '',
          valueName: '所有人',
          valueList: []
        };
      } 
      // 如果是DEPT，设置部门信息
      else if (this.v_start === 'DEPT') {
        if (this.fromList && this.fromList.length > 0) {
          this.approverConfig.nodeUserType.valueList = this.fromList.map(dept => dept.ID);
          this.approverConfig.nodeUserType.value = this.fromList.map(dept => dept.ID).join(',');
          this.approverConfig.nodeUserType.valueName = this.fromList.map(dept => dept.CNAME).join(',');
        }
      } 
      // 如果是USER，设置用户信息
      else if (this.v_start === 'USER') {
        if (this.userList && this.userList.length > 0) {
          this.approverConfig.nodeUserType.valueList = this.userList.map(user => user.EMPNO);
          this.approverConfig.nodeUserType.value = this.userList.map(user => user.EMPNO).join(',');
          this.approverConfig.nodeUserType.valueName = this.userList.map(user => user.EMPNM).join(',');
        }
      }
      
      // 更新节点配置
      this.$set(this.nodeConfig, 'nodeUserType', JSON.parse(JSON.stringify(this.approverConfig.nodeUserType)));
      this.$emit('starter-updated', this.approverConfig);
    },
 
    //审批人抄送人显示和校验
    setApproverStr(nodeConfig) {
      let type = ''
      if (!nodeConfig || !nodeConfig.nodeUserType) return '';
      
      const nodeUserType = nodeConfig.nodeUserType;
      
      // 发起人节点 type === 0
      if (nodeConfig.type === 0 || nodeConfig.type === '0') {
        
        // 明确处理ALL类型的情况，无需检查valueList
        if (nodeUserType.type === 'ALL') {
          return `由：所有人 发起`;
        }
        
        if (nodeUserType.type === 'USER') {
          return `由用户：${nodeUserType.valueName || ''} 发起`;
        } else if (nodeUserType.type === 'DEPT') {
          return `由部门：${nodeUserType.valueName || ''} 发起`;
        } else {
          // 如果nodeUserType.type未设置但有valueList和valueName，默认按用户处理
          if (nodeUserType.valueList && nodeUserType.valueList.length > 0 && nodeUserType.valueName) {
            return `由用户：${nodeUserType.valueName || ''} 发起`;
          }
          // 如果type未设置或不是上述值，默认显示所有人
          return `由：所有人 发起`;
        }
      }
      
      // 检查valueList和value是否有值
      const hasValue = nodeUserType.value || 
                      (nodeUserType.valueList && nodeUserType.valueList.length > 0);
                      
      if (!hasValue) return '';

      // 审批节点 type === 1
      if (nodeConfig.type === 1 || nodeConfig.type === '1') {
        if (nodeConfig.examineMode === '1') type = ''
        if (nodeConfig.examineMode === '2') type = ''
        return `由${nodeUserType.type === 'manager' ? '主管' : '用户'}：${nodeUserType.valueName || ''}${type}`
      }
      
      // 抄送节点 type === 2
      if (nodeConfig.type === 2 || nodeConfig.type === '2') {
        return `抄送：${nodeUserType.valueName || ''}`
      }
      
      return '';
    },
    //保存 审批人，抄送人，条件分支
    saveApprover() {
      if (this.approverConfig.type === 3 || this.approverConfig.type === '3') {  //条件分支
        this.saveCondition()
        return
      }
      if (this.userList.length == 0) {
        this.promptWin = true;
        this.prompt = this.approverConfig.type == 1 || this.approverConfig.type === '1' 
          ? '请选择审核人' 
          : '请选择抄送人';
      } else {
        // 确保 nodeUserType 对象存在并且格式正确
        if (!this.approverConfig.nodeUserType) {
          this.approverConfig.nodeUserType = {
            type: '',
            value: '',
            valueName: '',
            valueList: [],
            deptNames: ''
          };
        }
        
        // 更新 nodeUserType 数据
        this.approverConfig.nodeUserType.valueList = this.userList.map(user => user.EMPNO);
        this.approverConfig.nodeUserType.value = this.userList.map(user => user.EMPNO).join(',');
        this.approverConfig.nodeUserType.valueName = this.userList.map(user => user.EMPNM).join(',');
        this.approverConfig.nodeUserType.deptNames = this.userList.map(user => user.DEPTNM || '').join(',');
        
        // 检查错误状态
        this.approverConfig.error = this.setApproverStr(this.approverConfig) === '';
        
        // 通过hasFlag区分添加节点后自动出现弹框及点击出现弹框
        if (this.hasFlag) {
          if (this.nodeConfig.conditionNodes && this.nodeConfig.conditionNodes.length > 0 && this.conditionTip) {  //条件分支
            this.nodeConfig.conditionNodes.forEach(element => {
              if (element.childNode && (!element.childNode.nodeUserType.value && element.childNode.nodeName === this.approverConfig.nodeName)) {  //条件分支节点赋值
                element.childNode = this.approverConfig;
              }
            });
          } else {
            this.nodeConfig.childNode = this.approverConfig;
          }

          this.$emit('update:nodeConfig', this.nodeConfig);
        } else {
          this.$emit('update:nodeConfig', this.approverConfig);
        }
        
        // 清空用户列表，避免下次打开时数据混淆
        this.userList = [];
        this.v_uchk = 'N'; // 重置全选复选框
        
        this.approverWin = false;
      }
    },
    //保存条件设置
    saveCondition() {
      this.approverWin = false;
      let conditionString = ''; // 后端要的数据
      let conditionStringName = ''; //前端显示
      
      //条件循环设置
      if (this.approverConfig.conditionList.length > 0) {
        this.approverConfig.conditionList.forEach((item, indx) => {
          if (item.conditionChildrenNodes && item.conditionChildrenNodes.length > 0) {
            
            item.conditionChildrenNodes.forEach((it, ind) => {
              if (ind ==0) {
                conditionString = conditionString +   it.leftFileds + it.centerFileds + it.rightFileds;
                conditionStringName = conditionStringName +  it.leftFiledsName + it.centerFileds + it.rightFileds;
              }else{
                conditionString = conditionString +' and '+   it.leftFileds + it.centerFileds + it.rightFileds;
                conditionStringName =  conditionStringName +' and '+  it.leftFiledsName + it.centerFileds + it.rightFileds;
              }
            })
          }
    
        })
      }
      // 移除字符串中的 "null" 文本
      conditionString = (conditionString || '').replace(/null/g, '');
      conditionStringName = (conditionStringName || '').replace(/null/g, '');
      
      this.approverConfig.conditionString = conditionString;
      this.approverConfig.conditionStringName = conditionStringName;
      for (var i = 0; i < this.conditionsConfig.conditionNodes.length; i++) {
        this.conditionsConfig.conditionNodes[i].error =
          this.conditionStr(this.conditionsConfig.conditionNodes[i], i) == '请设置条件ddd'
      }
  
      // 区分添加节点后自动出现弹框及点击出现弹框
      if (this.hasFlag) {
        this.nodeConfig.childNode = this.conditionsConfig;
        this.$emit('update:nodeConfig', this.nodeConfig);
      } else {
        this.$emit('update:nodeConfig', this.conditionsConfig)
      }
    },
    //条件字段显示name
    dataFieldsChange(it) {
      this.dataFields.forEach((item) => {
        if (item.key === it.leftFileds) {
          this.$set(it, 'leftFiledsName', item.name)
          this.$set(it, 'leftFiledsType', item.type)
        }
      })
    },
    //删除节点
delNode(nodeConfig) {
  // 保存被删除节点的完整信息
  const deletedNode = JSON.parse(JSON.stringify(nodeConfig));
  
  // 确保deletedNodeIds是一个数组
  if (!this.deletedNodeIds) {
    this.deletedNodeIds = [];
  }
  
  // 收集要删除的节点IDSEQ
  const idsToDelete = [];
  
  // 判断节点类型
  const nodeType = deletedNode.type;
  
  // 1. 收集节点本身的IDSEQ
  if (deletedNode.IDSEQ) {
    idsToDelete.push(deletedNode.IDSEQ);
  }
  
  // 2. 根据节点类型决定是否需要级联删除子节点
  if (nodeType === 3 || nodeType === 4) {
    // 路由节点(4)和条件节点(3)需要级联删除子节点
    this.collectNodeAndChildrenIds(deletedNode, idsToDelete);
  } else {
    // 审批人(1)和抄送人(2)节点只删除自己，不删除子节点
  }
  
  // 3. 将收集到的IDSEQ添加到deletedNodeIds数组中
  if (idsToDelete.length > 0) {
    this.deletedNodeIds = this.deletedNodeIds.concat(idsToDelete);
    
    // 批量发送删除节点的ID数组
    this.$emit('nodes-deleted-batch', [...idsToDelete]);
    this.$root.$emit('workflow-nodes-deleted-batch', [...idsToDelete]);
  }
  
  // 在删除操作后，向父组件传递所有deletedNodeIds，确保它们被保存
  this.$nextTick(() => {
    this.emitDeletedNodeIds();
  });
  
  // 用子节点替换当前节点
  this.$emit('update:nodeConfig', this.nodeConfig.childNode);
},
    //添加条件
    addTerm() {
      let len = this.nodeConfig.conditionNodes.length;
      this.nodeConfig.conditionNodes.push({
        nodeName: '条件' + len,
        type: 3,
        priorityLevel: len + 1,
        conditionList: [{
          conditionChildrenNodes: [{
            leftFileds: '',
            centerFileds: '=',
            rightFileds: '',
          }],
          conditionGroupOperator: '',
        }],
        childNode: null,
      })
      for (var i = 0; i < this.nodeConfig.conditionNodes.length; i++) {
        this.nodeConfig.conditionNodes[i].error =
          this.conditionStr(this.nodeConfig.conditionNodes[i], i) ==
          '请设置条件' &&
          i != this.nodeConfig.conditionNodes.length - 1
      }
      this.$emit('update:nodeConfig', this.nodeConfig)
    },
    //删除条件
    delTerm(index) {
      // 确保deletedNodeIds是一个数组
      if (!this.deletedNodeIds) {
        this.deletedNodeIds = [];
      }
      
      // 获取要删除的条件节点
      const deletedCondition = this.nodeConfig.conditionNodes[index];
      
      // 收集要删除的所有节点的IDSEQ
      const idsToDelete = [];
      
      // 检查条件分支数量
      const conditionCount = this.nodeConfig.conditionNodes.length;
      
      // 只有当条件分支只有2个时(删除后只剩1个)，才收集路由节点本身的IDSEQ
      if (conditionCount === 2) {
        if (this.nodeConfig.IDSEQ) {
          idsToDelete.push(this.nodeConfig.IDSEQ);
        }
      }
      
      // 1. 收集条件节点本身的IDSEQ
      if (deletedCondition.IDSEQ) {
        idsToDelete.push(deletedCondition.IDSEQ);
      }
      
      // 2. 收集该条件节点的子节点IDSEQ
      if (deletedCondition.childNode) {
        this.collectNodeAndChildrenIds(deletedCondition.childNode, idsToDelete);
      }
      
      // 3. 将收集到的IDSEQ添加到deletedNodeIds数组中
      if (idsToDelete.length > 0) {
        this.deletedNodeIds = this.deletedNodeIds.concat(idsToDelete);
        
        // 批量发送删除节点的ID数组
        this.$emit('nodes-deleted-batch', [...idsToDelete]);
        this.$root.$emit('workflow-nodes-deleted-batch', [...idsToDelete]);
      }
      
      // 4. 从数组中移除条件节点
      this.nodeConfig.conditionNodes.splice(index, 1);
      
      // 5. 更新剩余条件节点的错误状态
      for (var i = 0; i < this.nodeConfig.conditionNodes.length; i++) {
        this.nodeConfig.conditionNodes[i].error =
          this.conditionStr(this.nodeConfig.conditionNodes[i], i) ==
          '请设置条件' &&
          i != this.nodeConfig.conditionNodes.length - 1;
      }
      
      // 6. 通知父组件更新节点配置
      this.$emit('update:nodeConfig', this.nodeConfig);
      
      // 7. 特殊处理：如果只剩一个条件节点，可能需要将其替换为普通节点
      if (this.nodeConfig.conditionNodes.length == 1) {
        // 7.1 收集剩余条件节点的IDSEQ
        const remainingCondition = this.nodeConfig.conditionNodes[0];
        if (remainingCondition.IDSEQ) {
          if (!this.deletedNodeIds.includes(remainingCondition.IDSEQ)) {
            this.deletedNodeIds.push(remainingCondition.IDSEQ);
            
            // 发送单个节点ID
            this.$emit('nodes-deleted-batch', [remainingCondition.IDSEQ]);
            this.$root.$emit('workflow-nodes-deleted-batch', [remainingCondition.IDSEQ]);
          }
        }
        
        // 7.2 再次确认路由节点IDSEQ已被收集 (只有在条件数原本为2时才需要)
        if (conditionCount === 2 && this.nodeConfig.IDSEQ && !this.deletedNodeIds.includes(this.nodeConfig.IDSEQ)) {
          this.deletedNodeIds.push(this.nodeConfig.IDSEQ);
          
          // 发送单个节点ID
          this.$emit('nodes-deleted-batch', [this.nodeConfig.IDSEQ]);
          this.$root.$emit('workflow-nodes-deleted-batch', [this.nodeConfig.IDSEQ]);
        }
        
        // 7.3 继续原有逻辑，调整节点结构
        if (this.nodeConfig.childNode) {
          if (this.nodeConfig.conditionNodes[0].childNode) {
            this.reData(
              this.nodeConfig.conditionNodes[0].childNode,
              this.nodeConfig.childNode
            );
          } else {
            this.nodeConfig.conditionNodes[0].childNode = this.nodeConfig.childNode;
          }
        }
        
        // 7.4 将唯一剩余的条件分支的子节点提升为当前节点
        this.$emit('update:nodeConfig', this.nodeConfig.conditionNodes[0].childNode);
      }
      
      // 在删除操作后，向父组件传递所有deletedNodeIds，确保它们被保存
      this.$nextTick(() => {
        this.emitDeletedNodeIds();
      });
    },
    reData(data, addData) {
      if (!data.childNode) {
        data.childNode = addData
      } else {
        this.reData(data.childNode, addData)
      }
    },
    //打开弹框
    setPerson(priorityLevel, item, data, tip) {
      this.approverWin = true
      this.hasFlag = false
      if (tip) {
        this.conditionTip = tip;
      }
      
      // 先清空用户列表
      this.userList = [];
      
      if (data) {   //添加节点自动出现弹框传值
        this.hasFlag = true;
        // 条件
        if (priorityLevel == 1) {
          this.bPriorityLevel = priorityLevel;
          this.conditionsConfig = JSON.parse(JSON.stringify(data));
          this.approverConfig = this.conditionsConfig.conditionNodes[priorityLevel - 1];
          
          // 确保条件节点有默认条件组和条件
          if (!this.approverConfig.conditionList || this.approverConfig.conditionList.length === 0) {
            this.approverConfig.conditionList = [{
              conditionChildrenNodes: [{
                leftFileds: '',
                centerFileds: '=',
                rightFileds: '',
              }],
              conditionGroupOperator: '',
            }];
          }
          return
        }
        // 审批人、抄送人
        this.approverConfig = JSON.parse(JSON.stringify(data));
      } else {  //点击出现弹框
        // 条件
        let { type } = this.nodeConfig;
        if (type == 4) {
          this.bPriorityLevel = priorityLevel;
          this.conditionsConfig = JSON.parse(JSON.stringify(this.nodeConfig));
          this.approverConfig = this.conditionsConfig.conditionNodes[priorityLevel - 1];
          
          // 确保条件节点有默认条件组和条件
          if (!this.approverConfig.conditionList || this.approverConfig.conditionList.length === 0) {
            this.approverConfig.conditionList = [{
              conditionChildrenNodes: [{
                leftFileds: '',
                centerFileds: '=',
                rightFileds: '',
              }],
              conditionGroupOperator: '',
            }];
          }
          return
        }
        // 发起人、审批人、抄送人
        this.approverConfig = JSON.parse(JSON.stringify(this.nodeConfig));
      }
      
      // 如果是审批人或抄送人，且已经有选择的用户，则加载这些用户
      if ((this.approverConfig.type == 1 || this.approverConfig.type == 2) && this.approverConfig.nodeUserType) {
        const nodeUserType = this.approverConfig.nodeUserType;
        
        // 如果有值列表和名称
        if (nodeUserType.valueList && nodeUserType.valueList.length > 0) {
          const valueList = Array.isArray(nodeUserType.valueList) ? nodeUserType.valueList : nodeUserType.valueList.split(',');
          const valueNames = nodeUserType.valueName ? nodeUserType.valueName.split(',') : [];
          const deptNames = nodeUserType.deptNames ? nodeUserType.deptNames.split(',') : Array(valueList.length).fill('');
          
          // 添加已选择的用户到userList
          for (let i = 0; i < valueList.length; i++) {
            this.userList.push({
              CHK: 'N',
              EMPNO: valueList[i],
              EMPNM: valueNames[i] || valueList[i],
              DEPTNM: deptNames[i] || ''
            });
          }
        } else if (nodeUserType.value) {
          // 处理单个值的情况
          const values = nodeUserType.value.split(',');
          const names = nodeUserType.valueName ? nodeUserType.valueName.split(',') : values;
          const deptNames = nodeUserType.deptNames ? nodeUserType.deptNames.split(',') : Array(values.length).fill('');
          
          for (let i = 0; i < values.length; i++) {
            this.userList.push({
              CHK: 'N',
              EMPNO: values[i],
              EMPNM: names[i] || values[i],
              DEPTNM: deptNames[i] || ''
            });
          }
        }
      }
    },
    
    // 向根组件发送节点ID
    sendDeletedNodeId(nodeId) {
      if (nodeId) {
        this.$root.$emit('workflow-node-deleted', nodeId);
      }
    },
 
    arrTransfer(index, type = 1) {
      //向左-1,向右1
      this.nodeConfig.conditionNodes[index] = this.nodeConfig.conditionNodes.splice(index + type, 1, this.nodeConfig.conditionNodes[index])[0];
      this.nodeConfig.conditionNodes.map((item, index) => {
        item.priorityLevel = index + 1
      })
      for (var i = 0; i < this.nodeConfig.conditionNodes.length; i++) {
        this.nodeConfig.conditionNodes[i].error =
          this.conditionStr(this.nodeConfig.conditionNodes[i], i) ==
          '请设置条件' &&
          i != this.nodeConfig.conditionNodes.length - 1
      }
      this.$emit('update:nodeConfig', this.nodeConfig)
    },
 

    isDepartmentChecked(dept) {
      return this.checkedDepartmentList.some(item => item.id === dept.id);
    },
    //获取表列字段
    getTabField(){
        let vm =this
        this.$axios({method: 'post',url:this.v_url,data: {p_key:'idseq',p_value:'446085',p_key2:'lstseq',p_value2:'2', p_table:'v_sys_form_fld',p_cond:' order by sortby'},}).then(res=>{ 
            for (let k=0; k<res.result.length; k++){
                vm.tabArr.push({ //向数组的开头 添加序列号
                    title: res.result[k].title,
                    key: res.result[k].key,
                    align: res.result[k].align,
                    width: res.result[k].width,
                    thide:res.result[k].THIDE,
                    fhide:res.result[k].FHIDE,
                    edcss:res.result[k].EDCSS,
                    sortable:res.result[k].SORTABLE,
                    disabled:res.result[k].DISABLED,
                })
            }
        })

    },
    // 新增方法：将节点ID直接发送到根组件
    emitNodeDeletedToRoot(nodeId) {
      if (nodeId) {
        // 使用$root.$emit向根组件发送事件
        this.$root.$emit('workflow-node-deleted', nodeId);
      }
    },
    // 保存人员信息
    savePersonData() {
      this.approverWin = false;
      
      // 保存发起人信息
      if (this.approverConfig.type == 0) {
        this.nodeConfig.nodeUserType = JSON.parse(JSON.stringify(this.approverConfig.nodeUserType));
        this.$emit('starter-updated', this.nodeConfig);
      }
      
      // 处理条件分支情况
      if (this.conditionsConfig) {
        let conditionString = '';
        let conditionStringName = '';
        
        this.conditionsConfig.conditionList.forEach(item => {
          if (item.conditionChildrenNodes && item.conditionChildrenNodes.length > 0) {
            item.conditionChildrenNodes.forEach((it, ind) => {
              if (ind == 0) {
                conditionString = conditionString + it.leftFileds + it.centerFileds + it.rightFileds;
                conditionStringName = conditionStringName + it.leftFiledsName + it.centerFileds + it.rightFileds;
              } else {
                conditionString = conditionString + ' and ' + it.leftFileds + it.centerFileds + it.rightFileds;
                conditionStringName = conditionStringName + ' and ' + it.leftFiledsName + it.centerFileds + it.rightFileds;
              }
            });
          }
        });
        
        // 移除字符串中的 "null" 文本
        conditionString = (conditionString || '').replace(/null/g, '');
        conditionStringName = (conditionStringName || '').replace(/null/g, '');
        
        this.approverConfig.conditionString = conditionString;
        this.approverConfig.conditionStringName = conditionStringName;
        
        // 更新条件节点的错误状态
        for (var i = 0; i < this.conditionsConfig.conditionNodes.length; i++) {
          this.conditionsConfig.conditionNodes[i].error =
            this.conditionStr(this.conditionsConfig.conditionNodes[i], i) == '请设置条件ddd';
        }
        
        // 区分添加节点后自动出现弹框及点击出现弹框
        if (this.hasFlag) {
          this.nodeConfig.childNode = this.conditionsConfig;
          this.$emit('update:nodeConfig', this.nodeConfig);
        } else {
          this.$emit('update:nodeConfig', this.conditionsConfig);
        }
      }
    },
    //保存审批人设置
    saveNodeType() {
      this.approverWin = false
      
      if (this.hasFlag) {
        this.nodeConfig.childNode = this.conditionsConfig;
        this.$emit('update:nodeConfig', this.nodeConfig);
      } else {
        this.$emit('update:nodeConfig', this.conditionsConfig)
      }
    }
  },
}
</script>
<style lang="less">
.el-dialog__title {
  font-size: 18px !important;
  font-weight: 600 !important;
}
.default-style {
  margin-left: 25px;
}
.search-style {
  label {
    width: 50px !important;
  }
  .el-row {
    padding-right: 0px !important;
  }
  .el-form-item__content {
    margin-left: 50px !important;
  }
}
.flex-style {
  display: flex;
  justify-content: space-between;
}
.dang-style {
  font-size: 14px;
}
.dialog-style {
  z-index: 99999 !important;
  background: rgba(0, 0, 0, 0.5);
}
.v-modal {
  background: none !important;
  z-index: -1 !important;
}
//弹框
.set_promoter {
  .el-drawer__header {
    margin-bottom: 0;
    padding: 0 24px;
    border-bottom: 1px solid #ebebeb;

    .title {
      height: 64px;
      line-height: 64px;
      font-size: 20px;
      color: #333;
      justify-content: flex-start;

      i {
        margin-left: 8px;
        font-size: 30px;
      }
    }
  }

  .el-drawer__body {
    overflow-y: auto;
    max-height: calc(100% - 64px);
    padding-bottom: 80px;
  }

  .drawer-content {
    padding: 24px;

    .el-radio {
      margin-bottom: 16px;

      .mark {
        color: #828282;
      }

      &.is-checked {
        .mark {
          color: #4880ff;
        }
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .drawer-content-condition {
    padding: 24px 0;

    .condition-conent-group {
      border-bottom: solid 1px #ebebeb;
      padding-bottom: 20px;

      .condition-group-title {
        padding: 0 24px;
        background: #f7f8fa;
        height: 48px;
        border-top: solid 1px #ebebeb;
        border-bottom: solid 1px #ebebeb;
        margin-bottom: 12px;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      .condition-group-select {
        padding: 0 24px;
      }

      .remove {
        color: #828282;

        &:hover {
          cursor: pointer;
          color: #4880ff;
        }
      }

      .mg-bot-10 {
        margin-bottom: 10px;
      }

      .conditionbtn {
        .el-button {
          border: 1px dashed #4880ff;
          width: 110px;
        }
      }
    }

    .conditionbtn {
      padding: 0 24px;
      margin-top: 26px;

      .el-button {
        border: solid 1px #4880ff;
        color: #4880ff;
        width: 123px;
      }
    }
  }

  .set_promoter_footer {
    height: 80px;
    position: absolute;
    bottom: 0;
    left: 0;
    padding: 24px;
    justify-content: flex-end;
    background: #fff;
    width: 100%;
    border-top: 1px solid #ebebeb;
    z-index: 2;
  }

  .icon-icon_explain {
    color: #bfbfbf;
  }
}
.error_tip {
  position: absolute;
  top: 36px;
  right: 0px;
  transform: translate(150%, 0px);

  i {
    font-size: 24px;
  }
}

.add-node-popover-body {
  display: flex;
}

.el-drawer:focus,
.el-drawer__close-btn:focus {
  outline: none;
}
.transfer-style {
  margin-top:60px;
  margin-left: 20px;
}

/* 发起人弹窗样式 */
.promoter_person {
  width: 100%;
  min-height: 560px;
  height: 560px;
}

.person_body {
  display: flex;
  padding: 20px;
}

.person_body .l {
  flex: 1;
}

.person_tree {
  border: 1px solid #E4E7ED;
  border-radius: 4px;
  margin-right: 20px;
  padding: 10px;
}

.person_tree input {
  width: 100%;
  height: 36px;
  line-height: 36px;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  padding: 0 15px;
  margin-bottom: 10px;
}

.tree_nav {
  background-color: #F5F7FA;
  height: 36px;
  line-height: 36px;
  padding: 0 10px;
  margin: 10px 0;
  border-radius: 4px;
}

.tree_nav span {
  display: inline-block;
  margin-right: 8px;
  cursor: pointer;
  color: #409EFF;
}

.tree_nav span:after {
  content: '/';
  margin-left: 8px;
  color: #606266;
}

.tree_nav span:last-child:after {
  content: '';
}

.select-box-container {
  border: 1px solid #E4E7ED;
  border-radius: 4px;
  padding: 10px;
}

.dept-item, .emp-item, .role-item {
  padding: 8px 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  border-radius: 4px;
}

.dept-item:hover, .emp-item:hover, .role-item:hover {
  background-color: #F5F7FA;
}

.dept-item.active, .emp-item.active, .role-item.active {
  background-color: #EBF5FF;
  color: #409EFF;
}

.dept-header {
  display: flex;
  align-items: center;
  width: 100%;
}

.dept-name, .emp-name, .role-name {
  margin-left: 8px;
  flex: 1;
}

.select-result {
  width: 250px;
  border: 1px solid #E4E7ED;
  border-radius: 4px;
}

.result-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid #E4E7ED;
}

.result-content {
  padding: 10px;
  height: 400px;
  overflow-y: auto;
}

.result-group {
  margin-bottom: 15px;
}

.group-title {
  font-weight: bold;
  margin-bottom: 8px;
  color: #606266;
}
 
.clear {
  &:after {
    content: "";
    display: block;
    clear: both;
  }
}

.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 抄送人到流程结束的连接线样式 */
.node-to-end-line {
  width: 240px;
  display: flex;
  justify-content: center;
  position: relative;
  padding: 20px 0;
}

.vertical-line {
  width: 2px;
  height: 100%;
  background-color: #cacaca;
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 0;
}
</style>
<style scoped lang="scss">
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 1px auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1000;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
</style>